import * as R from 'ramda'

import { EMPTY_OBJECT } from 'constants/commonConstans'

export const isAnyEdited = (font = EMPTY_OBJECT) => R.any((edited) => edited, R.values(font))
